export const scrollMixin = {
    mounted() {
        const oTrack = document.getElementById('track')
        const oScrollBar = document.getElementById('scrollBar')
        const oWrapper = document.getElementById('wrapper')
        const oContent = document.getElementById('content')
        oScrollBar.onmousedown = function (e) {
            const spaceY = e.clientY - this.offsetTop
            document.onmousemove = function (e) {
                window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty()
                let y = e.clientY - spaceY
                y = (y <= 0 ? 0 : y)
                y = (y > oTrack.clientHeight - oScrollBar.clientHeight ? oTrack.clientHeight - oScrollBar.clientHeight : y)
                oScrollBar.style.top = `${y}px`
                const maxScroll = oContent.clientHeight - oWrapper.clientHeight
                const scroll = maxScroll * y / (oTrack.clientHeight - oScrollBar.clientHeight)
                oWrapper.scrollTop = scroll
            }
        }
        oWrapper.onscroll = function () {
            const maxScroll = oContent.clientHeight - oWrapper.clientHeight
            let barTop = this.scrollTop * (oTrack.clientHeight - oScrollBar.clientHeight) / maxScroll
            barTop = (barTop > oTrack.clientHeight - oScrollBar.clientHeight ? oTrack.clientHeight - oScrollBar.clientHeight : barTop)
            oScrollBar.style.top = `${barTop}px`
        }
        document.onmouseup = function () {
            document.onmousemove = null
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/scrollMixin.js